import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Box from "@mui/system/Box";
import ImageContainer from "@shared/components/contents/imageContainer/ImageContainer";
import React from "react";
const transitionDuration = "350ms";
const transitionEasing = "ease";
const Trombinoscope = (props) => {
    const { id, image, imageHover, position: subtitle, name, firstName, link, textColor: color, textColorHover: colorHover, backgroundColor, backgroundColorHover, ...others } = props;
    return (_jsxs(Box, { tabIndex: 0, sx: {
            width: 260,
            maxWidth: "100%",
            height: 386,
            margin: "0 auto",
            position: "relative",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-end",
            alignItems: "flex-start",
            p: 0,
            isolation: "isolate",
            overflow: "hidden",
            "&:hover, &:focus-within": {
                "& .trombinoscope-image-default": {
                    transform: imageHover
                        ? "translateX(-100%) translateZ(0)"
                        : "translateX(0) translateZ(0)",
                },
                "& .trombinoscope-image-hover": {
                    transform: "translateX(0) translateZ(0)",
                },
                "& .trombinoscope-content": {
                    bgcolor: backgroundColorHover || "#FFFF80",
                    transform: "translateX(40px)",
                },
                "& p": {
                    color: colorHover || "text.primary",
                },
            },
        }, ...others, children: [(image || imageHover) && (_jsxs(Box, { sx: {
                    position: "absolute",
                    width: "100%",
                    height: "350px",
                    left: 0,
                    top: 0,
                    zIndex: 1,
                    overflow: "hidden",
                    "& img": {
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        display: "block",
                    },
                }, children: [image && (_jsx(Box, { className: "trombinoscope-image-default", sx: {
                            position: "absolute",
                            inset: 0,
                            transform: "translateX(0) translateZ(0)",
                            transition: `transform ${transitionDuration} ${transitionEasing}`,
                            willChange: "transform",
                            backfaceVisibility: "hidden",
                        }, children: _jsx(ImageContainer, { ratio: "", children: image }) })), imageHover && (_jsx(Box, { className: "trombinoscope-image-hover", sx: {
                            position: "absolute",
                            inset: 0,
                            transform: "translateX(100%) translateZ(0)",
                            transition: `transform ${transitionDuration} ${transitionEasing}`,
                            willChange: "transform",
                            backfaceVisibility: "hidden",
                        }, children: _jsx(ImageContainer, { ratio: "", children: imageHover }) }))] })), _jsxs(Stack, { className: "trombinoscope-content", spacing: 1.5, sx: {
                    position: "relative",
                    justifyContent: "center",
                    alignItems: "flex-start",
                    gap: "10px",
                    width: 220,
                    padding: "20px",
                    zIndex: 2,
                    bgcolor: backgroundColor || "#0000FF",
                    transform: "translateX(0)",
                    transition: `transform ${transitionDuration} ${transitionEasing}, background-color ${transitionDuration} ${transitionEasing}`,
                    willChange: "transform",
                }, children: [(name || firstName) && (_jsxs(Typography, { variant: "subtitle1", component: "p", sx: {
                            color: color || "primary.contrastText",
                            lineHeight: "125%",
                        }, children: [firstName || "", _jsx("br", {}), name || ""] })), subtitle && (_jsx(Typography, { variant: "body2", component: "p", sx: {
                            color: color || "primary.contrastText",
                        }, children: subtitle })), link && (_jsx("a", { href: link, children: _jsx("img", { src: "/linkedin_logo.svg", alt: "Logo LinkedIn", width: 20 }) }))] })] }, id));
};
export default Trombinoscope;
